import React from 'react';

const templates = [
    { id: 'modern', name: 'Modern', icon: 'fas fa-layer-group' },
    { id: 'classic', name: 'Classic', icon: 'fas fa-book' },
    { id: 'minimal', name: 'Minimal', icon: 'fas fa-square' },
    { id: 'professional', name: 'Professional', icon: 'fas fa-briefcase' }
];

const colors = [
    { value: '#2c3e50', name: 'Navy' },
    { value: '#333333', name: 'Dark Grey' },
    { value: '#555555', name: 'Grey' },
    { value: '#000000', name: 'Black' }
];

const fonts = [
    { value: "'Inter', sans-serif", name: 'Modern' },
    { value: "'Playfair Display', serif", name: 'Elegant' },
    { value: "'Montserrat', sans-serif", name: 'Clean' },
    { value: "'Lato', sans-serif", name: 'Professional' }
];

const TemplateOptions = ({ template, setTemplate, color, setColor, font, setFont }) => {
    return (
        <div className="bg-gray-50 p-4 rounded-xl mb-6">
            <h3 className="font-bold text-gradpath-dark mb-3">Template Settings</h3>
            
            {/* Template Selection */}
            <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">Template</label>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
                    {templates.map(t => (
                        <button
                            key={t.id}
                            onClick={() => setTemplate(t.id)}
                            className={`px-3 py-2 rounded-lg text-sm font-medium transition-all flex items-center justify-center gap-2 ${
                                template === t.id
                                    ? 'bg-gradpath-green text-white'
                                    : 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-100'
                            }`}
                        >
                            <i className={t.icon}></i>
                            {t.name}
                        </button>
                    ))}
                </div>
            </div>
            
            {/* Color Selection */}
            <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">Accent Color</label>
                <div className="flex flex-wrap gap-2">
                    {colors.map(c => (
                        <button
                            key={c.value}
                            onClick={() => setColor(c.value)}
                            className={`w-10 h-10 rounded-full transition-all ${
                                color === c.value ? 'ring-2 ring-offset-2 ring-gradpath-green' : ''
                            }`}
                            style={{ backgroundColor: c.value }}
                            title={c.name}
                        />
                    ))}
                </div>
            </div>
            
            {/* Font Selection */}
            <div className="mb-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">Font Style</label>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
                    {fonts.map(f => (
                        <button
                            key={f.value}
                            onClick={() => setFont(f.value)}
                            className={`px-3 py-2 rounded-lg text-sm transition-all ${
                                font === f.value
                                    ? 'bg-gradpath-green text-white'
                                    : 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-100'
                            }`}
                            style={{ fontFamily: f.value }}
                        >
                            {f.name}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default TemplateOptions;